import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { FirmenstandortDto } from '@app/dto/firmenstandort.dto';
import { FirmenIndexFirmaDto } from '@app/dto/firmen.index.firma.dto';
import { FirmenService } from '@app/services/firmen.service';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { CommentPopupComponent } from '@app/comment-popup/comment-popup.component';

interface FormElement {
  name: string;
  defaultValue: string | boolean;
  children?: FormElement[];
}
@Component({
  selector: 'app-pc-adresse-neu-zuordnen',
  templateUrl: './pc-adresse-neu-zuordnen.component.html',
  styleUrls: ['./pc-adresse-neu-zuordnen.component.scss']
})
export class PcAdresseNeuZuordnenComponent implements OnInit {

  title: string = "";
  isSaveButtonDisabled: boolean = true;
  selectedElementLabel: string;
  selectedElement: string;

  pcAdresseNeueZuordnungForm: FormGroup = new FormGroup({
    startingOptionSelected:                     new FormControl(''),
    gleicheFirmaOptionSelected:                 new FormControl(''),
    andereFirmaOptionSelected:                  new FormControl({ value: null, disabled: true }),
    andereFirmaSelected:                        new FormControl([]),
    andereFirmaAndererFirmenstandortSelected:   new FormControl([]),
    gleicheFirmaAndererFirmenstandortSelected:  new FormControl([]),
    neueFirmaFirmenname:                        new FormControl('', Validators.required),
    neueFirmaStrasseUndHausnummer:              new FormControl('', Validators.required),
    neueFirmaPlz:                               new FormControl('', Validators.required),
    neueFirmaOrt:                               new FormControl('', Validators.required),
    neueFirmaLaenderCode:                       new FormControl('', Validators.required),
    neuerFirmenstandortStrasseUndHausnummer:    new FormControl('', Validators.required),
    neuerFirmenstandortPlz:                     new FormControl('', Validators.required),
    neuerFirmenstandortOrt:                     new FormControl('', Validators.required),
    neuerFirmenstandortLaenderCode:             new FormControl('', Validators.required),
    searchFirmenname:                           new FormControl(''),
    searchFirmenId:                             new FormControl(''),
    kommentar:                                  new FormControl(''),
  })

  pcAdresseNeueZuordnungFormHierarchy!: FormElement;

  startingOptions = [
    {
      text: 'Innerhalb der Firma neu zuordnen',
      value: 'gleiche_firma'
    },
    {
      text: 'Einer anderen Firma zuordnen',
      value: 'andere_firma'
    },
    {
      text: 'Eine neue Firma und einen neuen (Haupt-)Standort erstellen',
      value: 'neue_firma'
    },
  ]

  andereFirmaOptions = [
    {
      text: 'neuer Standort',
      value: 'neuer_standort'
    },
  ]

  andereFirmaDataSource: any;
  displayedAndereFirmaColumns: string[] = [
    'firmenname',
    'firmenId',
    'strasseUndHausnummer',
    'plz',
    'ort',
    'selectAndereFirma',
  ];
  andereFirmaResultListLength = 0;
  andereFirmaPageSize = 5;

  andereFirmenstandorteDataSource: any;
  displayedAndereFirmenstandorteColumns: string[] = [
    'info',
    'selectAndererFirmenstandort',
  ];

  aktuelleFirmenId: number;
  aktuellerFirmenstandorteId: number;
  aktuellerPcAdressenId: number;

  @ViewChild('gleiche_firma') gleicheFirma!: ElementRef;
  @ViewChild('andere_firma') andereFirma!: ElementRef;
  @ViewChild('neue_firma') neueFirma!: ElementRef;

  constructor(
      private dialogRef: MatDialogRef<PcAdresseNeuZuordnenComponent>,
      @Inject(MAT_DIALOG_DATA) public dialogData: any,
      private firmenService: FirmenService,
      public dialogKommentar: MatDialog,
  ) {
    this.title                      = dialogData.title;
    this.aktuelleFirmenId           = dialogData.firmenId;
    this.aktuellerFirmenstandorteId = dialogData.firmenstandortId;
    this.aktuellerPcAdressenId      = dialogData.pcAdresseId;

    this.selectedElementLabel       = dialogData.selectedElementLabel;
    this.selectedElement            = dialogData.selectedElement;
  }

  ngOnInit(): void {
    this.pcAdresseNeueZuordnungForm.controls['neueFirmaFirmenname'].setValue(this.dialogData.firmenname);
    this.pcAdresseNeueZuordnungForm.controls['neueFirmaStrasseUndHausnummer'].setValue(this.dialogData.strasseUndHausnummer);
    this.pcAdresseNeueZuordnungForm.controls['neueFirmaPlz'].setValue(this.dialogData.plz);
    this.pcAdresseNeueZuordnungForm.controls['neueFirmaOrt'].setValue(this.dialogData.ort);
    this.pcAdresseNeueZuordnungForm.controls['neueFirmaLaenderCode'].setValue(this.dialogData.laendercode);

    this.pcAdresseNeueZuordnungForm.controls['neuerFirmenstandortStrasseUndHausnummer'].setValue(this.dialogData.strasseUndHausnummer);
    this.pcAdresseNeueZuordnungForm.controls['neuerFirmenstandortPlz'].setValue(this.dialogData.plz);
    this.pcAdresseNeueZuordnungForm.controls['neuerFirmenstandortOrt'].setValue(this.dialogData.ort);
    this.pcAdresseNeueZuordnungForm.controls['neuerFirmenstandortLaenderCode'].setValue(this.dialogData.laendercode);

    this.pcAdresseNeueZuordnungFormHierarchy = {
      name: 'startingOptionSelected',
      defaultValue: '',
      children:
          [
            {
              name: 'gleicheFirmaOptionSelected',
              defaultValue: '',
              children: [
                {
                  name: 'gleicheFirmaAndererFirmenstandortSelected',
                  defaultValue: '',
                },
                {
                  name: 'neuerFirmenstandortStrasseUndHausnummer',
                  defaultValue: this.dialogData.strasseUndHausnummer,
                },
                {
                  name: 'neuerFirmenstandortPlz',
                  defaultValue: this.dialogData.plz,
                },
                {
                  name: 'neuerFirmenstandortOrt',
                  defaultValue: this.dialogData.ort,
                },
                {
                  name: 'neuerFirmenstandortLaenderCode',
                  defaultValue: this.dialogData.laendercode,
                },
              ]
            },
            {
              name: 'searchFirmenname',
              defaultValue: '',
              children: [
                {
                  name: 'andereFirmaSelected',
                  defaultValue: '',
                  children: [
                    {
                      name: 'andereFirmaOptionSelected',
                      defaultValue: '',
                      children: [
                        {
                          name: 'andereFirmaAndererFirmenstandortSelected',
                          defaultValue: '',
                        },
                        {
                          name: 'neuerFirmenstandortStrasseUndHausnummer',
                          defaultValue: this.dialogData.strasseUndHausnummer,
                        },
                        {
                          name: 'neuerFirmenstandortPlz',
                          defaultValue: this.dialogData.plz,
                        },
                        {
                          name: 'neuerFirmenstandortOrt',
                          defaultValue: this.dialogData.ort,
                        },
                        {
                          name: 'neuerFirmenstandortLaenderCode',
                          defaultValue: this.dialogData.laendercode,
                        },
                      ]
                    }
                  ]
                }
              ]
            },
            {
              name: 'searchFirmenId',
              defaultValue: '',
              children: [
                {
                  name: 'andereFirmaSelected',
                  defaultValue: '',
                  children: [
                    {
                      name: 'andereFirmaOptionSelected',
                      defaultValue: '',
                      children: [
                        {
                          name: 'andereFirmaAndererFirmenstandortSelected',
                          defaultValue: '',
                        },
                        {
                          name: 'neuerFirmenstandortStrasseUndHausnummer',
                          defaultValue: this.dialogData.strasseUndHausnummer,
                        },
                        {
                          name: 'neuerFirmenstandortPlz',
                          defaultValue: this.dialogData.plz,
                        },
                        {
                          name: 'neuerFirmenstandortOrt',
                          defaultValue: this.dialogData.ort,
                        },
                        {
                          name: 'neuerFirmenstandortLaenderCode',
                          defaultValue: this.dialogData.laendercode,
                        },
                      ]
                    }
                  ]
                }
              ]
            },
            {
              name: 'neueFirmaFirmenname',
              defaultValue: this.dialogData.firmenname,
            },
            {
              name: 'neueFirmaStrasseUndHausnummer',
              defaultValue: this.dialogData.strasseUndHausnummer,
            },
            {
              name: 'neueFirmaPlz',
              defaultValue: this.dialogData.plz,
            },
            {
              name: 'neueFirmaOrt',
              defaultValue: this.dialogData.ort,
            },
            {
              name: 'neueFirmaLaenderCode',
              defaultValue: this.dialogData.laendercode,
            },
          ]
    }
  }

  resetFormElementChildren(element: FormElement) {
    element.children?.forEach(child => {
      this.pcAdresseNeueZuordnungForm.controls[child.name].setValue(child.defaultValue);
      if (child.children) this.resetFormElementChildren(child);
    })
  }

  findFormElement(formElementChildren: FormElement[] | undefined, elementName: string): FormElement | undefined {
    if (formElementChildren) {
      for (let i = 0; i < formElementChildren.length; i++) {
        if (formElementChildren[i].name == elementName) {
          return formElementChildren[i];
        }
        let found = this.findFormElement(formElementChildren[i].children, elementName);
        if (found) return found;
      }
    }
  }

  resetFormElement(elementName: string) {
    let foundFormElement;
    if (elementName == this.pcAdresseNeueZuordnungFormHierarchy.name) {
      foundFormElement = this.pcAdresseNeueZuordnungFormHierarchy;
    } else {
      foundFormElement = this.findFormElement(this.pcAdresseNeueZuordnungFormHierarchy.children, elementName);
    }
    if (foundFormElement) {
      this.resetFormElementChildren(foundFormElement);
    }
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }

  checkSaveButtonForDisable() {
    if (this.pcAdresseNeueZuordnungForm.touched && this.pcAdresseNeueZuordnungForm.status !== 'VALID' || this.pcAdresseNeueZuordnungForm.errors) {
      this.isSaveButtonDisabled = true;
    }
    else if (this.pcAdresseNeueZuordnungForm.value.startingOptionSelected == 'neue_firma') {
      this.isSaveButtonDisabled = !(this.pcAdresseNeueZuordnungForm.value.neueFirmaFirmenname || this.pcAdresseNeueZuordnungForm.value.neueFirmaStrasseUndHausnummer
          || this.pcAdresseNeueZuordnungForm.value.neueFirmaPlz || this.pcAdresseNeueZuordnungForm.value.neueFirmaOrt || this.pcAdresseNeueZuordnungForm.value.neueFirmaLaenderCode);
    }
    else if (this.pcAdresseNeueZuordnungForm.value.startingOptionSelected == 'andere_firma' && this.pcAdresseNeueZuordnungForm.value.andereFirmaOptionSelected == 'anderer_standort'
        && this.pcAdresseNeueZuordnungForm.value.andereFirmaAndererFirmenstandortSelected.id && this.pcAdresseNeueZuordnungForm.value.andereFirmaSelected.firmenId) {
      this.isSaveButtonDisabled = false;
    }
    else if (this.pcAdresseNeueZuordnungForm.value.startingOptionSelected == 'andere_firma' && this.pcAdresseNeueZuordnungForm.value.andereFirmaOptionSelected == 'neuer_standort') {
      this.isSaveButtonDisabled = !(this.pcAdresseNeueZuordnungForm.value.neuerFirmenstandortStrasseUndHausnummer || this.pcAdresseNeueZuordnungForm.value.neuerFirmenstandortPlz
          || this.pcAdresseNeueZuordnungForm.value.neuerFirmenstandortOrt || this.pcAdresseNeueZuordnungForm.value.neuerFirmenstandortLaenderCode);
    }
    else if (this.pcAdresseNeueZuordnungForm.value.startingOptionSelected == 'gleiche_firma' && this.pcAdresseNeueZuordnungForm.value.gleicheFirmaOptionSelected == 'anderer_standort'
        && this.pcAdresseNeueZuordnungForm.value.gleicheFirmaAndererFirmenstandortSelected.id && this.aktuelleFirmenId) {
      this.isSaveButtonDisabled = false;
    }
    else if (this.pcAdresseNeueZuordnungForm.value.startingOptionSelected == 'gleiche_firma' && this.pcAdresseNeueZuordnungForm.value.gleicheFirmaOptionSelected == 'neuer_standort') {
      this.isSaveButtonDisabled = !(this.pcAdresseNeueZuordnungForm.value.neuerFirmenstandortStrasseUndHausnummer || this.pcAdresseNeueZuordnungForm.value.neuerFirmenstandortPlz
          || this.pcAdresseNeueZuordnungForm.value.neuerFirmenstandortOrt || this.pcAdresseNeueZuordnungForm.value.neuerFirmenstandortLaenderCode);
    }
    else {
      this.isSaveButtonDisabled = true;
    }
    return this.isSaveButtonDisabled;
  }

  openDialogKommentar(event: Event): void {
    this.dialogKommentar.open(CommentPopupComponent, {
      panelClass: 'kommentar',
      data: {}
    }).afterClosed().subscribe(kommentar => {
      if (kommentar !== undefined && typeof kommentar == 'string') {
        this.pcAdresseNeueZuordnungForm.controls['kommentar'].setValue(kommentar.trim());
        this.dialogRef.close(this.pcAdresseNeueZuordnungForm.value);
      }
      event.stopPropagation();
    });
  }

  save(event: Event) {
    this.dialogRef.close(this.pcAdresseNeueZuordnungForm.value);
    //this.openDialogKommentar(event);
  }

  close() {
    this.dialogRef.close();
  }

  checkIfGleicheFirma() {
    if (this.pcAdresseNeueZuordnungForm.get('startingOptionSelected')?.value == 'gleiche_firma') {
      this.listAndereFirmenstandorte();
    }
  }

  listAndereFirmen(skip: number) {
    if (this.pcAdresseNeueZuordnungForm.value.startingOptionSelected == 'andere_firma') {
      if (this.pcAdresseNeueZuordnungForm.value.searchFirmenname) {
        this.firmenService.getFirmen(`${this.pcAdresseNeueZuordnungForm.value.searchFirmenname}*`, 'firmenname',
            'any', 'full', 'search.score() desc,firmenname', this.andereFirmaPageSize,
            skip, true, 'includeGeloeschte eq false')
            .subscribe(result => {
              if (result) {
                this.andereFirmaResultListLength = result['@odata.count'];
                this.andereFirmaDataSource = new MatTableDataSource(result.value);
              }
            })
      }
      else if (this.pcAdresseNeueZuordnungForm.value.searchFirmenId) {
        this.firmenService.getFirmen(`${this.pcAdresseNeueZuordnungForm.value.searchFirmenId}`, 'firmenId',
            'any', 'full', 'search.score() desc,firmenname', this.andereFirmaPageSize,
            skip, true, 'includeGeloeschte eq false')
            .subscribe(result => {
              if (result) {
                this.andereFirmaResultListLength = result['@odata.count'];
                this.andereFirmaDataSource = new MatTableDataSource(result.value);
              }
            })
      }
    }
  }

  getAndereFirmenPageData(event: PageEvent) {
    let skip = event.pageIndex * this.andereFirmaPageSize;
    this.listAndereFirmen(skip);
  }

  selectAndereFirma(row: FirmenIndexFirmaDto) {
    this.pcAdresseNeueZuordnungForm.controls['andereFirmaSelected'].setValue(row);
    this.pcAdresseNeueZuordnungForm.controls['andereFirmaOptionSelected'].enable();

    this.listAndereFirmenstandorte();
  }

  selectGleicheFirmaAndererFirmenstandort(row: FirmenstandortDto) {
    this.pcAdresseNeueZuordnungForm.controls['gleicheFirmaAndererFirmenstandortSelected'].setValue(row);
  }

  selectAndereFirmaAndererFirmenstandort(row: FirmenstandortDto) {
    this.pcAdresseNeueZuordnungForm.controls['andereFirmaAndererFirmenstandortSelected'].setValue(row);
  }

  listAndereFirmenstandorte() {
    let firmenId;
    if (this.pcAdresseNeueZuordnungForm.value.startingOptionSelected == 'andere_firma') {
      firmenId = this.pcAdresseNeueZuordnungForm.value.andereFirmaSelected.firmenId;
    } else if (this.pcAdresseNeueZuordnungForm.value.startingOptionSelected == 'gleiche_firma' && this.aktuelleFirmenId) {
      firmenId = this.aktuelleFirmenId;
    }
    if (firmenId) {
      this.firmenService.getFirmenstandorteByFirmenId(firmenId, 'includeGeloeschte eq false').subscribe(result => {
        if (result) {
          let otherFirmenstandorteList = result.filter(element => element.id != this.aktuellerFirmenstandorteId);
          if (otherFirmenstandorteList && otherFirmenstandorteList.length > 0) {
            let hasDuplicate = this.andereFirmaOptions.map(andereFirmaOption => andereFirmaOption.value).indexOf('anderer_standort') !== -1;
            if (hasDuplicate === false) {
              this.andereFirmaOptions.push({
                text: 'anderer vorhandener Standort',
                value: 'anderer_standort'
              });
            }
            this.andereFirmenstandorteDataSource = new MatTableDataSource(otherFirmenstandorteList);
          }
        }
      });
    }
  }

  waitAndScroll(id: string) {
    this.waitForElement(id);
  }

  waitForElement(selector: string) {
    let element = document.getElementById(selector);
    if (element) {
      scroll(selector);
      return;
    }
    let observer = new MutationObserver(mutations => {
      mutations.forEach(function (mutation) {
        let nodes = Array.from(mutation.addedNodes);
        for (var node of nodes) {
          if (node.contains(document.getElementById(selector))) {
            scroll(selector);
            observer.disconnect();
            return;
          }
        }
      });
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
}

function scroll(id: string) {
  document.getElementById(id)?.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
    inline: 'nearest'
  });
}
